<template>
    <div>
        <template v-if="loading">
            <ActionModal
                :text="$t('loading-form')"
                :modalStyle="{ height: 'auto' }"
                class="mb-1"
            />
        </template>
        <template v-else-if="error">
            <ActionModal
                :title="$t('error')"
                :text="$t('could-not-load-form')"
                :modalStyle="{ height: 'auto' }"
                iconType="exclamation-triangle-fill"
                iconVariant="danger"
                class="mb-1"
            />
        </template>
        <template v-else-if="formresponse">
            <router-link class="mx-auto h3" :to="`/forms/view/${formresponse.formresponse_id}`">
                {{ formresponse.formresponse_data.title }} <b-icon icon="link" />
            </router-link>
            <br />{{ $t('created-colon') }} {{ $datetime.getLocaleStringFromTimeStamp(formresponse.created, true) }}
            <template v-for="(page, pageIndex) in filteredPages">
                <div class="card mb-3" :key="pageIndex" v-if="pageNum == pageIndex + 1">
                    <div class="card-body">
                        <h3 class="card-title" v-if="page.title">{{ page.title }}</h3>
                        <FormGrid
                            :page="page"
                            :formresponse="formresponse"
                            readonly="true"
                            viewAs="submitter"
                        />
                    </div>
                </div>
            </template>
            <div class="clearfix mb-3">
                <button class="btn btn-secondary" v-if="showPreviousPageBtn" @click="previousPage">
                    {{ $t('previous-page') }}
                </button>
                <button class="btn btn-primary ml-2" v-if="showNextPageBtn" @click="nextPage">
                    {{ $t('next-page') }}
                </button>
            </div>
        </template>
    </div>
</template>

<script>
import ActionModal from 'src/components/ActionModal.vue';
import FormGrid from 'src/components/FormEditor/FormGrid';

export default {
    components: { ActionModal, FormGrid },
    props: {
        formresponseId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            formresponse: null,
            loading: false,
            error: false,
            pageNum: 1
        };
    },
    computed: {
        filteredPages() {
            if (!this.formresponse || !this.formresponse.formresponse_data) return [];
            return this.formresponse.formresponse_data.pages || [];
        },
        showNextPageBtn() {
            return this.formresponse
                && this.formresponse.formresponse_data
                && this.formresponse.formresponse_data.next
                && this.pageNum < this.filteredPages.length;
        },
        showPreviousPageBtn() {
            return this.formresponse
                && this.formresponse.formresponse_data
                && this.formresponse.formresponse_data.previous
                && this.pageNum > 1;
        }
    },
    watch: {
        formresponseId: {
            handler(id) {
                if (id) {
                    this.fetch(id);
                } else {
                    this.formresponse = null;
                    this.error = false;
                }
            },
            immediate: true
        }
    },
    methods: {
        fetch(id) {
            this.loading = true;
            this.error = false;
            this.formresponse = null;
            this.pageNum = 1;
            this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/load/${id}`)
                .then(res => {
                    if (res.status === 'SUCCESS') {
                        this.formresponse = res.formresponse;
                    } else {
                        this.error = true;
                    }
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        nextPage() {
            if (this.pageNum < this.filteredPages.length) this.pageNum++;
        },
        previousPage() {
            if (this.pageNum > 1) this.pageNum--;
        }
    }
};
</script>

<style scoped>
::v-deep .btn-group {
    display: block !important;
}
</style>
